import React from 'react';
import autoBind from 'react-autobind';
import { observer } from 'mobx-react';
import {action} from 'mobx';
import store from '../store/store.js'


import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';


/**
 * Alerts are urgent interruptions, requiring acknowledgement, that inform the user about a situation.
 */
@observer
class DialogMob extends React.Component {
/*  props:
*   message = string
*   okButton = string
*   cancelButton = string
*   onOk = func
*   onCancel = func
*   buttons = bool
*/

  constructor (props){
    super(props);
    autoBind(this);

  }

  @action handleClose = () => {
    store.dialog.open = false;
  }

  onOk = () => {
    this.handleClose();
    store.dialogOk();
  }

  onCancel = () => {
    this.handleClose();
    store.dialogCancel(); 
  }

  render() {
    let actions;
    if ( store.dialog.buttons ) {
      actions = [
        <FlatButton
          label={store.dialog.okButton}
          primary={true}
          onClick={this.onOk}
        />,
        <FlatButton
          label={store.dialog.cancelButton}
          primary={true}
          onClick={this.onCancel}
        />,
      ] 
    } else { actions = [ 
        <FlatButton
          label={store.dialog.okButton}
          primary={true}
          onClick={this.handleClose}
        />
        ] };

    return (
      <div>
        <Dialog
          title={store.dialog.title}
          actions={actions}
          modal={false}
          open={store.dialog.open}
          onRequestClose={store.dialog.buttons ? this.onCancel : this.handleClose}
        >
          {store.dialog.message}
        </Dialog>
      </div>
    );
  }
}

export default DialogMob;


// WEBPACK FOOTER //
// ./src/coms/DialogMob.jsx